import { Mail, Clock, HelpCircle, CreditCard, RefreshCw, AlertTriangle, FileText } from 'lucide-react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import styles from './Contact.module.css';

export function ContactSupport() {
  const topics = [
    { icon: <CreditCard />, label: 'Payment Issue' },
    { icon: <RefreshCw />, label: 'Refund Request' },
    { icon: <FileText />, label: 'Report Not Generated' },
    { icon: <AlertTriangle />, label: 'Scanner Failed' },
    { icon: <HelpCircle />, label: 'Credit Missing' },
  ];

  return (
    <div className="app">
      <Header />
      <main className={styles.contactPage}>
        <div className={styles.container}>
          <header className={styles.header}>
            <div className={styles.label}>Support Center</div>
            <h1>How can we help?</h1>
            <p className={styles.subtitle}>Our professional support team is ready to assist you with any technical or billing inquiries.</p>
          </header>
          
          <div className={styles.contactGrid}>
            <div className={styles.supportInfo}>
              <div className={styles.infoCard}>
                <div className={styles.icon}><Mail /></div>
                <div>
                  <h3>Email Support</h3>
                  <a href="mailto:support@pccheckr.com" className={styles.emailLink}>support@pccheckr.com</a>
                </div>
              </div>
              
              <div className={styles.infoCard}>
                <div className={styles.icon}><Clock /></div>
                <div>
                  <h3>Response Target</h3>
                  <p>We typically respond within <strong>24–48 hours</strong>.</p>
                </div>
              </div>

              <div className={styles.topicsBox}>
                <h3>Common Support Topics</h3>
                <div className={styles.topicsGrid}>
                  {topics.map((topic, i) => (
                    <div key={i} className={styles.topicItem}>
                      <span className={styles.topicIcon}>{topic.icon}</span>
                      <span>{topic.label}</span>
                    </div>
                  ))}
                </div>
              </div>
            </div>
            
            <div className={styles.supportFormBox}>
              <h2>Send a Support Ticket</h2>
              <form className={styles.form} onSubmit={(e) => e.preventDefault()}>
                <div className={styles.formRow}>
                  <div className={styles.formGroup}>
                    <label>Your Name</label>
                    <input type="text" placeholder="John Doe" required />
                  </div>
                  <div className={styles.formGroup}>
                    <label>Email Address</label>
                    <input type="email" placeholder="john@example.com" required />
                  </div>
                </div>
                <div className={styles.formGroup}>
                  <label>Support Topic</label>
                  <select required>
                    <option value="">Select a topic...</option>
                    <option value="payment">Payment Issue</option>
                    <option value="refund">Refund Request</option>
                    <option value="report">Report Not Generated</option>
                    <option value="scanner">Scanner Failed</option>
                    <option value="credits">Credit Missing</option>
                    <option value="other">Other Inquiry</option>
                  </select>
                </div>
                <div className={styles.formGroup}>
                  <label>Message Details</label>
                  <textarea placeholder="Please describe your issue in detail..." rows={6} required></textarea>
                </div>
                <button type="submit" className={styles.submitBtn}>
                  Submit Ticket
                </button>
              </form>
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}
